import _axios from '@/plugins/axios'

export function getUserInfo() {
  return _axios({
    url: '/getInfo',
    method: 'get'
  })
}

// 保存用户手机号
export function savePhoneNumber(phoneNumber) {
  return _axios({
    url: '/wx/phone',
    method: 'put',
    data: { phoneNumber }
  })
}

